import React, { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import { ThemeContext } from '../Context/ThemeContext/ThemeContext'
import { db } from '../Firebase/firebase'

import Post from '../Reuable/Post/Post'
import LoadingIcon from '../LoadingIcon/LoadingIcon'

const PlatformHome = () => {
  const { isLight } = React.useContext(ThemeContext)
  const {platformName} = useParams()
  const [posts, setPosts] = useState([])
  const [loading, isLoading] = useState(true)

  //*Loads posts from database on load

  useEffect(() => {
    isLoading(true)
    db.collection('posts').where("platform","==", platformName).orderBy('createdAt', 'desc').get()
      .then(snapshot => {
        setPosts(snapshot.docs)
        isLoading(false)

      })
  }, [])

  return (
    <section className={`home ${isLight ? "" : "dark"}`}>
      {
        loading ? (
          <div className="loading-icon-container">
            <LoadingIcon />
          </div>
        ) : (
          <div className="home__container no-grid">
            <h1 className="home__header">Welcome to TP/{platformName}</h1>
            <div className="home__posts">
              {
                posts.map(post => {

                  return(
                    <Post key={post.id} id={post.id} props={post.data()}/>
                  )
                })
              }
            </div>
            
          </div>
        )
      }
      
    </section>
  )
}

export default PlatformHome
